import { useUnderwayStore } from './useUnderwayStore';
import type { UnderwayStatus } from './types';

const IN_FLIGHT_STATUSES: UnderwayStatus[] = ['pending', 'paused', 'running'];
const TERMINAL_STATUSES: UnderwayStatus[] = [
  'completed',
  'failed',
  'cancelled',
];

export type UnderwaySummary = {
  /** Whether any automation rows currently exist. */
  hasActivities: boolean;
  /** Total number of automation rows. */
  total: number;
  /** Rows still in flight (pending / paused / running). */
  inFlightCount: number;
  /** Share of rows that have reached a terminal state, 0–100. */
  progress: number;
};

/**
 * Read-only summary of the automation underway queue. This is the small,
 * stable public surface the shared bulk activities popup will consume to
 * decide visibility, contribute to the header count, and show sub-progress
 * — without reaching into the underway store internals.
 */
export const useUnderwaySummary = (): UnderwaySummary => {
  const activities = useUnderwayStore((s) => s.activities);

  const total = activities.length;
  const inFlightCount = activities.filter((a) =>
    IN_FLIGHT_STATUSES.includes(a.status)
  ).length;
  const terminalCount = activities.filter((a) =>
    TERMINAL_STATUSES.includes(a.status)
  ).length;

  return {
    hasActivities: total > 0,
    total,
    inFlightCount,
    progress: total === 0 ? 0 : Math.round((terminalCount / total) * 100),
  };
};
